module.exports = __webpack_public_path__ + "media/components/assets/icons/trash_icon-9c1646ff5c4c9eb0fe2ae269f013ecc7.svg";